import { supabase } from '@/core/database/supabase';
import { roleLabels, UserRole } from '@/config/navigation.config';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { Member, MemberStats, RoleDistribution, RecentInvitation } from '../types/membersList.types';

export const membersListService = {
  async getMembers(companyId: string): Promise<Member[]> {
    await enforceSettingsPermission('settings.members.view', { companyId });
    if (!companyId) return [];
    
    const { data: profiles, error } = await supabase
      .from('user_profiles')
      .select('*, team_members(teams(name)), user_roles(role_code)')
      .eq('company_id', companyId);

    if (error) {
      console.error('[membersListService] Error fetching members:', error);
      return [];
    }

    return (profiles || []).map(p => {
      let teamName = '';
      if (p.team_members && p.team_members.length > 0) {
        const team = (p.team_members[0] as any).teams;
        if (team && !Array.isArray(team)) {
          teamName = team.name;
        } else if (Array.isArray(team) && team.length > 0) {
          teamName = team[0].name;
        }
      }

      const roleCodes = p.user_roles?.map((r: any) => r.role_code) || [];
      const primaryRoleCode = roleCodes.length > 0 ? roleCodes[0] : p.role_code;
      
      const rolesArr = roleCodes.length > 0 
        ? roleCodes.map((code: string) => ({ code, name: roleLabels[code as UserRole] || code }))
        : [{ code: p.role_code, name: roleLabels[p.role_code as UserRole] || p.role_code }];

      const roleNames = rolesArr.map((r: any) => r.name).join(', ');

      return {
        id: p.id,
        fullName: p.full_name || 'Không rõ',
        email: p.email || '',
        phone: p.phone || 'N/A',
        roleCode: primaryRoleCode,
        roleName: roleNames,
        roles: rolesArr,
        groupName: teamName || 'Chưa phân nhóm',
        status: p.is_active === false ? 'locked' : 'active',
        avatarPath: p.avatar_path,
      };
    });
  },

  async getRecentInvitations(companyId: string): Promise<RecentInvitation[]> {
    // Mocking invitations for now as requested by previous implementation
    return [
      { id: '1', email: 'ngocthuy.dang@gmail.com', roleName: 'Kỹ sư hiện trường', sentAt: '15/05/2024 09:30', status: 'pending' },
      { id: '2', email: 'duchuy.pham@gmail.com', roleName: 'Nhân viên kỹ thuật', sentAt: '14/05/2024 16:20', status: 'pending' },
      { id: '3', email: 'linh.tran@gmail.com', roleName: 'Kế toán công trình', sentAt: '13/05/2024 11:10', status: 'pending' },
    ];
  }
};
